import {
  EAccountActionType,
  TAccountActions,
} from 'affiny-core/modules/account/actions';
import {
  changePasswordSaga,
  setPicturePrivacySaga,
} from 'affiny-core/modules/account/saga';
import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { ActionsOfType } from 'affiny-core/modules/helpers';
import { all, call, takeLatest } from 'redux-saga/effects';

export function* changePasswordSagaWeb(
  action: ActionsOfType<TAccountActions, EAccountActionType.CHANGE_PASSWORD>
) {
  try {
    yield call(changePasswordSaga, action);

    if (action.payload.resolve) action.payload.resolve();
  } catch (error) {
    if (action.payload.reject) action.payload.reject(error);
  }
}

export function* setPicturePrivacySagaWeb(
  action: ActionsOfType<TAccountActions, EAccountActionType.SET_PICTURE_PRIVACY>
) {
  yield call(setPicturePrivacySaga, action);
}

export function* accountSaga() {
  yield all([
    takeLatest(
      EAccountActionType.CHANGE_PASSWORD,
      handleAsyncStatus(changePasswordSagaWeb, EAsyncEventTypes.CHANGE_PASSWORD)
    ),
    takeLatest(
      EAccountActionType.SET_PICTURE_PRIVACY,
      handleAsyncStatus(
        setPicturePrivacySagaWeb,
        EAsyncEventTypes.SET_PICTURE_PRIVACY
      )
    ),
  ]);
}
